import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialWifiFeed: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.955 15.235h-1.52v-3.05h-1.53v-1.52h-1.52v-1.52h-1.53v-1.53h-1.52v-1.52h-1.52v-1.52h-3.05v-1.53h-4.57v-1.52h-9.14v3.05h9.14v1.52h4.57v1.52h3.05v1.53h1.52v1.52h1.52v1.52h1.53v3.05h1.52v4.57h1.53v9.15h3.04v-9.15h-1.52z\"/><path fill=\"currentColor\" d=\"M3.055 7.615v3.05h7.61v1.52h3.05v1.53h3.05v1.52h1.52v3.05h1.53v3.05h1.52v7.62h3.05v-7.62h-1.53v-3.05h-1.52v-3.05h-1.52v-1.52h-1.53v-1.53h-1.52v-1.52h-3.05v-1.52h-3.05v-1.53z\"/><path fill=\"currentColor\" d=\"M3.055 16.765h6.09v1.52h3.05v1.52h1.52v3.05h1.53v6.1h3.04v-6.1h-1.52v-3.05h-1.52v-1.52h-1.53v-1.52h-1.52v-1.53h-3.05v-1.52h-6.09zm0 7.61h-1.53v4.58h1.53v1.52h4.57v-1.52h1.52v-4.58h-1.52v-1.52h-4.57z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialWifiFeed
